require('./services/apple-pay.js');

module.exports = 'apple-pay';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/apple-pay/index.js
 ** module id = 70
 ** module chunks = 1
 **/